angular.module('leanlaw')
// eslint-disable-next-line arrow-body-style
.filter('trustReportFilter', () => {
  return function (items, filter) {
    let result = filterByAccount(items, filter);
    if (filter.include && filter.include.red) {
      result = result.filter(evergreenBelowTrust);
    }
    return result;
  };
  function evergreenBelowTrust(item) {
    if (item.client) {
      if (item.client.billing.billClient) {
        return item.evergreen && item.balance < item.evergreen;
      }
      // matter billed. Filter based on whether any matters needs to be shown
      return item.matters.find(m => m.balance < m.evergreen);
    }
    return item.evergreen && item.balance < item.evergreen;
  }
  function filterByAccount(items, filter) {
    if (!items) {
      return [];
    }
    if (!filter || !filter.trustAccount) {
      return items;
    }
    return items.filter(i => !i.trustAccount || i.trustAccount.id === filter.trustAccount.id);
  }
});